/* ROUGHCUT product pages — generated. ES5 only: the theme minifier targets es5. */
document.documentElement.className += ' rcjs';

/* Instagram's webview can silently lose a PDF. Warn before they pay. */
(function(){
  var bar=document.getElementById('igBar');
  if(/Instagram|FBAN|FBAV|FB_IAB/i.test(navigator.userAgent||'')||location.search.indexOf('ig=1')>-1)
    bar.className+=' on';
  document.getElementById('igX').onclick=function(){bar.className=bar.className.replace(/ on\b/,'');};
})();

/* gallery */
(function(){
  var hero=document.getElementById('heroImg'), box=document.getElementById('heroBox');
  var btns=document.querySelectorAll('#thumbs button');
  function pick(b){
    for(var k=0;k<btns.length;k++)
      btns[k].className=btns[k].getAttribute('data-fit')==='cut'?'cut':'';
    b.className=(b.getAttribute('data-fit')==='cut'?'cut ':'')+'on';
    hero.src=b.getAttribute('data-src');
    var fit=b.getAttribute('data-fit');
    box.className='hero'+(fit==='fill'?' fill':fit==='doc'?' doc':'');
  }
  for(var i=0;i<btns.length;i++) btns[i].onclick=function(){ pick(this); };
})();

/* format choice drives every price on the page, including the sticky bar */
(function(){
  var radios=document.querySelectorAll('.fmt input');
  var cta=document.querySelector('.info .cta');
  var sp=document.getElementById('stickPrice'), sf=document.getElementById('stickFmt');
  function sync(){
    for(var i=0;i<radios.length;i++) if(radios[i].checked){
      var row=radios[i].closest('label');
      var price=row.querySelector('.pr').textContent;
      var name=row.querySelector('.n').textContent;
      cta.textContent='Add to basket — '+price;
      sp.textContent=price; sf.textContent=name;
    }
  }
  for(var i=0;i<radios.length;i++) radios[i].addEventListener('change',sync);
  sync();
})();

/* Time until the next Friday print run. This is a real cut-off — printing
   happens in batches on Fridays — so the number is true. It is shown only
   when Printed & Shipped is selected, because it is only true for that. */
(function(){
  var box=document.getElementById('run'), out=document.getElementById('runLeft');
  if(!box) return;
  function nextRun(){
    var n=new Date(), d=new Date(n);
    d.setHours(9,0,0,0);                                  // the run leaves 9am Friday
    var days=(5-d.getDay()+7)%7;
    if(days===0 && n>d) days=7;                           // today's run has gone
    d.setDate(d.getDate()+days);
    return d;
  }
  function tick(){
    var ms=nextRun()-new Date();
    if(ms<0){ out.textContent='the next run'; return; }
    var h=Math.floor(ms/3600000), m=Math.floor(ms%3600000/60000);
    var dd=Math.floor(h/24);
    out.textContent = dd>0 ? (dd+' day'+(dd===1?'':'s')+' '+(h%24)+' hrs')
                           : (h+' hrs '+m+' min');
  }
  tick(); setInterval(tick,30000);
  function sync(){
    var r=document.querySelectorAll('.fmt input'), printed=false;
    for(var i=0;i<r.length;i++)
      if(r[i].checked && /print/i.test(r[i].closest('label').querySelector('.n').textContent))
        printed=true;
    box.className='run'+(printed?' on':'');
  }
  var r=document.querySelectorAll('.fmt input');
  for(var i=0;i<r.length;i++) r[i].addEventListener('change',sync);
  sync();
})();

/* the sticky bar appears once the real button has scrolled away */
(function(){
  var cta=document.querySelector('.info .cta'), bar=document.getElementById('stick');
  if(!cta||!('IntersectionObserver' in window)) return;
  new IntersectionObserver(function(e){
    bar.className='stick'+(e[0].isIntersecting?'':' up');
  },{threshold:0}).observe(cta);
})();

/* the film loads nothing until it is asked to */
(function(){
  var fs=document.querySelectorAll('.film');
  for(var n=0;n<fs.length;n++)(function(f){
    function play(ev){
      /* classList, not className.indexOf: 'on' is a substring of far too many
         words, and this file has been bitten by that before. */
      if(f.classList.contains('on')) return;
      if(ev){ ev.preventDefault(); ev.stopPropagation(); }
      var id=f.getAttribute('data-yt');
      var i=document.createElement('iframe');
      i.src='https://www.youtube.com/embed/'+id+
            '?autoplay=1&rel=0&modestbranding=1&playsinline=1'+
            (f.getAttribute('data-start')||'');
      i.title='Build-along';
      i.allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
      i.setAttribute('allowfullscreen','');
      i.setAttribute('frameborder','0');
      f.appendChild(i);
      f.classList.add('on');
    }
    var btn=f.querySelector('.play');
    if(btn) btn.onclick=play;
    /* The whole poster is the target, not just the button in the middle of it.
       The link is excluded so it can behave like a link. */
    f.addEventListener('click',function(ev){
      var t=ev.target;
      while(t && t!==f){
        if(t.className && (''+t.className).indexOf('ytOut')>-1) return;
        t=t.parentNode;
      }
      play(ev);
    });
  })(fs[n]);
})();

/* reveal */
(function(){
  var els=document.querySelectorAll('[data-rv]'), i;
  /* classList, not indexOf: 'origin' contains the substring 'in', so the
     old check decided that block was already revealed and left it at
     opacity:0 permanently. */
  function show(el){ el.classList.add('in'); }
  if(!('IntersectionObserver' in window)){
    for(i=0;i<els.length;i++) show(els[i]); return;
  }
  var io=new IntersectionObserver(function(es){
    for(var k=0;k<es.length;k++) if(es[k].isIntersecting){ show(es[k].target); io.unobserve(es[k].target); }
  },{rootMargin:'0px 0px -8% 0px'});
  for(i=0;i<els.length;i++){
    els[i].style.transitionDelay=((els[i].getAttribute('data-d')||0)*0.08)+'s';
    io.observe(els[i]);
  }
  setTimeout(function(){
    for(var k=0;k<els.length;k++)
      if(els[k].getBoundingClientRect().top<window.innerHeight*1.2) show(els[k]);
  },80);
})();


/* Live, the price on the button and on the sticky bar follow the chosen
   variant. The preview had static prices; here they come from the radios,
   which Liquid stamped with the real Shopify variant ids and prices. */
(function(){
  var radios=document.querySelectorAll('.buyform input[name="id"]');
  if(!radios.length) return;
  var cta=document.querySelector('.buyform .cta .ctaPrice');
  var sp=document.getElementById('stickPrice'), sf=document.getElementById('stickFmt');
  function sync(){
    for(var i=0;i<radios.length;i++) if(radios[i].checked){
      var row=radios[i].parentNode;
      var pr=row.querySelector('.pr'), nm=row.querySelector('.n');
      if(cta&&pr) cta.textContent=pr.textContent;
      if(sp&&pr) sp.textContent=pr.textContent;
      if(sf&&nm) sf.textContent=nm.textContent;
    }
  }
  for(var i=0;i<radios.length;i++) radios[i].addEventListener('change',sync);
  sync();
})();
